import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from '../axiosConfig';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import Carousel from './Carousel';
import useMediaQuery from '../hooks/useMediaQuery';
import Loader from '../components/BLoader';

const API_URL = process.env.REACT_APP_API_URL;

function Layout({ children }) {
  const [defaultApp, setDefaultApp] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const isMobileOrTablet = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    const storedApp = JSON.parse(localStorage.getItem('defaultApp'));
    if (storedApp) {
      setDefaultApp(storedApp);
      applyTheme(storedApp.themeId);
      setLoading(false);
    } else {
      fetchDefaultApp();
    }
  }, []);

  const fetchDefaultApp = async () => {
    try {
      const response = await axios.get(`${API_URL}/applications/getapp`, {
        params: { isDefault: 'true' },
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const appData = response.data.applications[0];
      setDefaultApp(appData);
      localStorage.setItem('defaultApp', JSON.stringify(appData));
      applyTheme(appData.themeId);
    } catch (error) {
      console.error('Failed to fetch default application', error);
    } finally {
      setLoading(false);
    }
  };

  const applyTheme = (themeId) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = 'theme-css';
    document.head.appendChild(link);

    link.onload = () => console.log('Theme loaded successfully');
    link.onerror = () => console.error('Failed to load theme CSS');
  };

  useEffect(() => {
    if (defaultApp) {
      document.title = defaultApp.name;
    }
  }, [defaultApp]);

  if (loading) return <Loader />;

  const isLoginPage = location.pathname === '/login';

  const logoUrl = defaultApp ? `${API_URL.replace('/api', '')}${defaultApp.logo}` : '/default-logo.png';

  return (
    <div className="wrapper">
        <Header />
      <Sidebar />
      <main className="main-content">
        {!isLoginPage && isMobileOrTablet && <Carousel />}
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
